<template>
  <v-dialog
      :model-value="modelValue"
      max-width="400"
      @click:outside="$emit('close')"
  >
    <v-card>
      <v-card-title class="pt-4">Generate state points</v-card-title>
      <v-card-text  class="pl-4 pt-0">
        The current state points will be replaced by automatically generated state points.
        <br><br>
        Are you sure you want to continue?
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn
            :loading="loading"
            @click="$emit('generate')"
            color="primary"
            text
        >
          Generate
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "StateGenerateDialog",
  props: {
    modelValue: {type: Boolean, required: true},
    loading: {type: Boolean, default: false},
  },
};
</script>
